import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH } from '../../constants/dims';
import imgResearch from '../../assets/img/ourResearch.png';
import H2 from '../landing/H2';

const Container = styled.section`
  width: 100%;
  position: relative;
  color: ${props => props.theme.getStarted.text};
  background-color: ${props => props.theme.ourResearch.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  height: 436px;
  background-image: url(${imgResearch});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;

  & > .text {
    width: 100%;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;
    color: white !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    & > h2,
    p {
      text-shadow: 0px 0px 10px black;
      opacity: 1;
    }
  }
`;

const Section = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
  padding: 40px 20px;
  box-sizing: border-box;

  & > div {
    max-width: ${TABLET_WIDTH}px;

    & > h2 {
      width: 100%;
      text-align: center;
    }
  }
`;

const Section1 = styled(Section)`
  color: ${props => props.theme.howKidsImprove.text};
  background-color: ${props => props.theme.howKidsImprove.backgroundColor};
`;

const PaymentCanceled = () => {
  useEffect(() => {
    document.title = 'Brainquake: Payment canceled!';
  }, []);

  return (
    <Container>
      <Header>
      </Header>

      <Section1>
        <div>
          <H2>Payment Canceled!</H2>
          <p>
          If you have any questions, please email
          <a href="mailto:info@brainquake.com" style={{color: "#FFB907"}}> info@brainquake.com</a>.
          </p>
        </div>
      </Section1>

    </Container>
  );
};

export default PaymentCanceled;
